import React, { useCallback, useState } from 'react';

import Button from '../../Button';

import { Container, Content, Header, ContentView, ButtonsView } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  id_pausa: number;
  handleDeletePausa: any;
}

const ModalPausaProgRemove: React.FC<ModalPARAMS> = ({
  id = 'modalPausaProgRemove',
  onClose = () => {},
  isVisible,
  id_pausa,
  handleDeletePausa,
}) => {
  const handleOutSideClick = useCallback(
    (e: any) => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  );

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalPausaProgRemove" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>Excluir pausa programada</h1>
        </Header>

        <ContentView>
          <h2>
            Excluindo esta pausa programada, sua loja ficará aberta neste
            período.
          </h2>
        </ContentView>

        <ButtonsView>
          <Button
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                onClose();
              }, 300);
            }}
            type="button"
            style={{
              backgroundColor: '#fff',
              border: '2px solid #1a83ff',
              color: '#1a83ff',
              fontSize: '18px',
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleDeletePausa(id_pausa)}
            type="submit"
            style={{
              paddingRight: '50px',
              paddingLeft: '50px',
              fontSize: '18px',
            }}
          >
            Excluir
          </Button>
        </ButtonsView>
      </Content>
    </Container>
  );
};

export default ModalPausaProgRemove;
